import { Localization } from '@aa-app-localization'
import { LocalizedRouting } from '@app-domains/navigation/types/navigation.types'
import { CategoryFragment, ChildCategoryFragment } from '@app-graphql/schema'
import { Translated, Translatable } from '@app-types/common.types'

export const isChildCategory = (
    category: CategoryFragment | ChildCategoryFragment,
): category is ChildCategoryFragment => {
    return !! (category as ChildCategoryFragment).parentId
}

export const translateCategory = (
    category: CategoryFragment | ChildCategoryFragment,
    lang: Localization.Locale,
): LocalizedRouting => {
    const translation = category.translations[lang]
    const highlightedItems = isChildCategory(category)
        ? []
        : (translation.highlightedItem?.filter((item): item is NonNullable<typeof item> => !! item) ?? [])

    return {
        id: category.id,
        name: translation.name,
        slug: translation.slug,
        highlightedItems,
        children: (category as CategoryFragment).children?.filter(
            (c): c is ChildCategoryFragment => !! c,
        ).map(
            (child) => translateCategory(child, lang),
        ),
    }
}

export function genericTranslate<T extends Translatable>(
    translatable: T,
    lang: Localization.Locale,
): Translated<T> {
    return {
        ...translatable.translations[lang],
        ...translatable,
    }
}
